/**
 * Power-ups found in crates on the road, and their garage upgrades (each level makes it last longer).
 * Shared so the server charges the real upgrade price.
 */
export type PowerUpId = 'shield' | 'magnet' | 'double' | 'siren' | 'launch';

export interface PowerUp {
  id: PowerUpId;
  name: string;
  blurb: string;
  /** Seconds at upgrade level 0. */
  baseSeconds: number;
  /** Extra seconds per upgrade level. */
  perLevel: number;
  icon: string;
}

export const POWER_UPS: readonly PowerUp[] = [
  { id: 'shield', name: 'Gye Nyame Shield', blurb: 'Takes one crash for you', baseSeconds: 14, perLevel: 2, icon: '🛡️' },
  { id: 'magnet', name: 'MoMo Magnet', blurb: 'Pulls in every coin nearby', baseSeconds: 10, perLevel: 2, icon: '🧲' },
  { id: 'double', name: 'Black Star ×2', blurb: 'Double score', baseSeconds: 12, perLevel: 2, icon: '⭐' },
  { id: 'siren', name: 'Siren Boost', blurb: 'Blast through traffic', baseSeconds: 5.5, perLevel: 1, icon: '🚨' },
  { id: 'launch', name: 'Speed-Ramp Launch', blurb: 'Super high hops', baseSeconds: 10, perLevel: 2, icon: '🚀' },
];

export const MAX_UPGRADE_LEVEL = 5;
/** Price of upgrade level 1..5, pesewas. */
export const UPGRADE_PRICES: readonly number[] = [30000, 70000, 140000, 240000, 400000];

export function powerUpSeconds(id: PowerUpId, level: number): number {
  const p = POWER_UPS.find((x) => x.id === id);
  if (!p) return 0;
  return p.baseSeconds + p.perLevel * Math.max(0, Math.min(MAX_UPGRADE_LEVEL, level));
}

/** Price of the given upgrade level (1-based), or null if out of range. */
export function upgradePrice(level: number): number | null {
  return UPGRADE_PRICES[level - 1] ?? null;
}

/** Garage item id for an upgrade level, e.g. "magnet:2". */
export function upgradeItemId(id: PowerUpId, level: number): string {
  return `${id}:${level}`;
}

/** A coin on the road is worth GH₵1, and a player can't plausibly collect more than one per this many metres. */
export const COIN_PESEWAS = 500;
export const METRES_PER_COIN_MAX = 2;
